// extracted by mini-css-extract-plugin
export default {"viewerGrid":"VodViewer_viewerGrid__CpZts","VodViewer":"VodViewer_VodViewer__2yXza"};